// eslint-disable-next-line import/prefer-default-export
export const DEFAULT_FEATURES = {
  profile: true,
  compactMenu: false,
  legend: true,
  locationList: true,
  onboarding: true,
  loader: true,

  // INTERNAL USAGE
  classification: false,
  filters: {
    availability: true,
    capacity: true,
    price: true,
    type: true,
    attribute: true,
    status: true,
    mimo: true,
    spaceType: true,
    commitmentDates: true,
  },
}
